import React, { MouseEventHandler, ReactNode } from "react";
import { CustomButtonContainer } from "./CustomButtonContainer";

interface CustomButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  open?: boolean;
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  iconComponent?: ReactNode;
  startIcon?: ReactNode;
  btnName: string;
  variant?: string;
  color?: string;
  size?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  open,
  className = "",
  onClick,
  iconComponent = null,
  startIcon = null,
  btnName,
  disabled = false,
  ...rest
}) => {
  return (
    <CustomButtonContainer
      aria-controls={open ? "basic-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={open ? "true" : undefined}
      onClick={onClick}
      className={className}
      disabled={disabled}
      {...rest}
    >
      {startIcon || iconComponent} &nbsp; {btnName}
    </CustomButtonContainer>
  );
};

export default CustomButton;
